var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('bread-crumb',{attrs:{"navigationArray":_vm.navigationLink}}),(_vm.getDetailedAboutTheWard && _vm.getDetailedAboutTheWard.text)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.getDetailedAboutTheWard.text)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }